import { Utilidades } from '../helper/utilidades';

export class SortGrid {
  selector!: string;
  desc!: boolean;

  public static isSortGrid(value: any): boolean {
    return Utilidades.isOfType<SortGrid>(value, 'selector');
  }
}
